import { StepId } from "@/domains/quiz/StepDefinitions";
import { getNextStep, getPrevStep, firstStep } from "@/domains/quiz/StepUtils";

export class GlobalStepState {
  constructor(private step: StepId = firstStep()) {}

  get() {
    return this.step;
  }

  next() {
    const next = getNextStep(this.step);
    if (!next) return { done: true };
    this.step = next;
    return { step: next };
  }

  prev() {
    const prev = getPrevStep(this.step);
    if (!prev) return { atStart: true };
    this.step = prev;
    return { step: prev };
  }
}
